import { Component } from 'react';
import { ContentPlaceholder } from './ContentPlaceholder';

export interface IProps {
  avatar?: boolean;
  description?: boolean;
}

export class PlaceholderHeader extends Component<IProps> {
  public render() {
    const { avatar, description } = this.props;
    return (
      <ContentPlaceholder height="80px">
        {avatar && <circle cx="20" cy="41" r="20" />}
        <rect x={avatar ? '60' : '0'} y="20" width="300" height="25" />
        {description && <rect x={avatar ? '60' : '0'} y="60" width="400" height="12" />}
      </ContentPlaceholder>
    );
  }
}
